import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../api/axiosInstance";

export const fetchTariffes = createAsyncThunk(
  "tariffes/fetchTariffes",
  async ({ isDeleted = false }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/api/v1/admin/plan?isDeleted=${isDeleted}`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchOrganizationsTariffes = createAsyncThunk(
  "tariffes/fetchOrganizationsTariffes",
  async ({}, { rejectWithValue }) => {
    const page = 0;
    const size = 200;
    try {
      const response = await axiosInstance.get(
        `/api/v1/admin/organization/subscription?page=${page}&size=${size}`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCurrentOrgSubscription = createAsyncThunk(
  "tariffes/fetchCurrentOrgSubscription",
  async ({ orgId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/api/v1/organization/${orgId}/subscription`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateOrganizationTariff = createAsyncThunk(
  "tariffes/updateOrganizationTariff",
  async ({ orgId, tariffData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/api/v1/organization/${orgId}/subscription`,
        tariffData
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const cancelOrganizationTariff = createAsyncThunk(
  "tariffes/cancelOrganizationTariff",
  async ({ orgId, subscriptionId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/api/v1/organization/${orgId}/subscription/${subscriptionId}/cancel`,
        {}
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const createTariff = createAsyncThunk(
  "tariffes/createTariff",
  async ({ tariffData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/api/v1/admin/plan`,
        tariffData
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateTariff = createAsyncThunk(
  "tariffes/updateTariff",
  async ({ tariffId, tariffData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/api/v1/admin/plan/${tariffId}`,
        tariffData
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const createTariffVersion = createAsyncThunk(
  "tariffes/createTariffVersion",
  async ({ tariffId, tariffVersionData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/api/v1/admin/plan/${tariffId}/version`,
        tariffVersionData
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateSubscriptionStatus = createAsyncThunk(
  "tariffes/updateSubscriptionStatus",
  async ({ organizationId, status }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/api/v1/admin/organization/subscription/${organizationId}/status`,
        { status }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteOrganizationSubscription = createAsyncThunk(
  "tariffes/deleteOrganizationSubscription",
  async ({ subscriptionId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        `/api/v1/admin/organization/subscription/${subscriptionId}`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteTariff = createAsyncThunk(
  "tariffes/deleteTariff",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/api/v1/admin/plan/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTariffVersions = createAsyncThunk(
  "tariffes/fetchTariffVersions",
  async ({ tariffId }, { rejectWithValue }) => {
    const page = 0;
    const size = 100;
    try {
      const response = await axiosInstance.get(
        `/api/v1/admin/plan/${tariffId}/version?page=${page}&size=${size}`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchLatestStats = createAsyncThunk(
  "tariffes/fetchLatestStats",
  async ({}, { rejectWithValue }) => {
    const page = 0;
    const size = 100;
    try {
      const response = await axiosInstance.get(
        `/api/v1/admin/metrics/latest?level=DAILY`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchMetricData = createAsyncThunk(
  "tariffes/fetchMetricData",
  async ({ fromDate, toDate, metricCode }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/api/v1/admin/metrics/history?level=DAILY&from=${fromDate}&to=${toDate}&metricCode=${metricCode}&systemWideOnly=true`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const setCurrentOrganizationsTariffesInfo = (value) => ({
  type: "SET_CURRENT_ORGANIZATIONS_TARIFFES_INFO",
  payload: value,
});

export const fetchPublicTariffes = createAsyncThunk(
  "tariffes/fetchPublicTariffes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/v1/public/plan`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const eternalTariffesIds = [8, 19, 21];

const tariffesSlice = createSlice({
  name: "tariffes",
  initialState: {
    tariffesArray: [],
    currentOrganizationsTariffesInfo: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTariffes.fulfilled, (state, action) => {
        const sortedArray = action.payload.sort((a, b) => {
          const isEternalA = eternalTariffesIds.includes(a.id);
          const isEternalB = eternalTariffesIds.includes(b.id);

          if (isEternalA && !isEternalB) return -1;
          if (!isEternalA && isEternalB) return 1;
          return a.id > b.id ? 1 : -1;
        });
        state.tariffesArray = action.payload;
      })
      .addCase("SET_CURRENT_ORGANIZATIONS_TARIFFES_INFO", (state, action) => {
        state.currentOrganizationsTariffesInfo = action.payload;
      });
  },
});

export default tariffesSlice.reducer;
